export default "__VITE_ASSET__Czob4t_f__"